module.exports = __webpack_public_path__ + "static/assets/b4de05fa40fe3df59c41f811b21f3c4f.png";